import { Box, Typography } from "@mui/material"
import { NeighborhoodDataDto } from "../../../models/neighborhood-data"
import { useDataType } from "../../../hooks/use-data-type";
import { useMapAttributeName } from "../../../hooks/use-map-attribute";

export type NeighborhoodInfoPanelData = NeighborhoodDataDto & { label: string };

export const NeighborhoodInfoPanel = ({ data }: { data?: NeighborhoodInfoPanelData }) => {
  const [_, getDataTypeString] = useDataType();
  const [mapAttributeName] = useMapAttributeName();

  const LabelItem = ( {label }: {label?: string}) => {
    const regex = /[()]/; // Regular expression to match parentheses
    if (label && regex.test(label)) {
      const labelParts = label.split('(');
      const subtitle = labelParts[1].replace(')', '');
      return (
        <>
          <Typography variant='subtitle1' sx={{ textAlign: 'center'}}>{labelParts[0]}</Typography>
          <Typography variant='subtitle1' sx={{ textAlign: 'center'}}>{subtitle}</Typography>
        </>
      )
    }
    
    return (<Typography variant='subtitle1' sx={{ textAlign: 'center'}}>{label}</Typography>)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <LabelItem label={data?.label} />
      <Box>
        <Typography 
          variant='body2' 
          style={{ display: 'inline-block' }}
        >
          {mapAttributeName + ':'}
        </Typography>
        <Typography variant='subtitle2' style={{ display: 'inline-block' }} sx={{ marginLeft: 1 }}>
          {getDataTypeString(data?.dataMean)}
        </Typography>
      </Box>
      <Box>
        <Typography 
          variant='body2' 
          style={{ display: 'inline-block' }}
          sx={{ marginBottom: 0 }}
        >
          {'Samples amount:'}
        </Typography>
        <Typography variant='subtitle2' style={{ display: 'inline-block' }} sx={{ marginLeft: 1 }}>
          {data?.dataCount}
        </Typography>
      </Box>
    </Box>
  )
}